import { render, staticRenderFns } from "./dropdownList.vue?vue&type=template&id=3124a44f&"
import script from "./dropdownList.vue?vue&type=script&lang=ts&"
export * from "./dropdownList.vue?vue&type=script&lang=ts&"
import style0 from "./dropdownList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports